/* Produktbeschreibung neben der Ausstattungsliste (L1, Freigabe 05.09.2026).
 *
 * Links der Fliesstext, rechts die Ausstattung als Kasten. Ohne Eingriff
 * liefen beide Spalten ungleich lang, und unter der kuerzeren blieb ein
 * Loch. Deshalb wird der Text auf die Hoehe des Kastens gekuerzt — nicht
 * auf eine feste Zeilenzahl, denn die Liste ist je Baureihe verschieden
 * lang. Ein Knopf klappt den vollen Text auf. Unter 750 px stehen die
 * Spalten untereinander; dort gilt eine feste Kuerzung auf sechs Zeilen.
 *
 * Ohne JavaScript steht der Text vollstaendig — die Kuerzung ist nur ein
 * Zustand (is-clamped), den dieses Modul setzt. Die Hoehe wandert als
 * CSS-Variable (--rc-lead-max) ans Element, das Stylesheet zeichnet.
 */
class RcAplusLead extends HTMLElement {
  connectedCallback() {
    this.text = this.querySelector('[data-aplus-text]');
    this.knopf = this.querySelector('[data-aplus-toggle]');
    this.kasten = this.querySelector('[data-aplus-check]');
    if (!this.text || !this.knopf || !this.kasten) return;

    this.offen = false;
    this.knopf.addEventListener('click', () => {
      this.offen = !this.offen;
      this.anwenden();
      if (!this.offen) this.knopf.focus();
    });

    /* Der Kasten aendert seine Hoehe mit der Spaltenbreite (Umbruch der
       Listenpunkte) — jede Aenderung rechnet die Kuerzung neu. */
    if ('ResizeObserver' in window) {
      this._ro = new ResizeObserver(() => this.anwenden());
      this._ro.observe(this.kasten);
    } else {
      window.addEventListener('resize', () => this.anwenden());
    }
    this.anwenden();
  }

  disconnectedCallback() {
    if (this._ro) this._ro.disconnect();
  }

  anwenden() {
    const mobil = !window.matchMedia('(min-width: 750px)').matches;
    const zeile = parseFloat(getComputedStyle(this.text).lineHeight) || 20;

    /* Erst ungekuerzt messen, sonst misst scrollHeight die Kuerzung mit. */
    this.classList.remove('is-clamped');
    const voll = this.text.scrollHeight;

    /* Der Knopf braucht Platz in der Spalte; hidden-Elemente messen 0. */
    this.knopf.hidden = false;
    const knopfHoehe = this.knopf.getBoundingClientRect().height;
    const luecke = parseFloat(getComputedStyle(this.text.parentElement).rowGap) || 0;

    let max = mobil
      ? zeile * 6
      : this.kasten.getBoundingClientRect().height - knopfHoehe - luecke;
    /* Auf ganze Zeilen runden, mindestens drei — sonst endet die Kuerzung
       mitten in einer Zeile oder der Text verschwindet fast ganz. */
    max = Math.max(zeile * 3, Math.floor(max / zeile) * zeile);

    const braucht = voll > max + zeile / 2;
    if (!braucht) {
      this.knopf.hidden = true;
      this.setzeLabel(false);
      return;
    }

    this.setzeLabel(this.offen);
    if (this.offen) return;
    this.style.setProperty('--rc-lead-max', max + 'px');
    this.classList.add('is-clamped');
  }

  setzeLabel(offen) {
    this.knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
    const mehr = this.knopf.querySelector('[data-aplus-more]');
    const weniger = this.knopf.querySelector('[data-aplus-less]');
    if (mehr) mehr.hidden = offen;
    if (weniger) weniger.hidden = !offen;
  }
}

customElements.define('rc-aplus-lead', RcAplusLead);
